import './social-network-history.component.ajscss';

import { forEach, IComponentController, IComponentOptions, ILogService, isDefined } from 'angular';
import { i18n } from 'i18next';

import { MomentService } from '@contact/upgrade';

import templateUrl from './social-network-history.component.html';

class HistorySocialNetworkCtrl implements IComponentController {
  private dimeloEvents: any;
  protected internalEvents: any;
  protected targetContact: any;
  protected targetCsr: any;
  protected targetTypeContact: number;
  protected availableCsr: any;
  protected availableContact: any;
  protected currentContactId: string;
  protected currentContact: any;
  protected selectSkills: string[];

  constructor(
    protected readonly $log: ILogService,
    protected readonly $i18next: i18n,
    protected readonly timeUtil: MomentService,
    protected readonly $sce: any
  ) {}

  $onChanges(): void {
    this.targetContact = 0;
    this.targetTypeContact = 0;
    this.targetCsr = null;
    this.availableCsr = this.dimeloEvents.csrMap;
    this.availableContact = this.dimeloEvents.contactMap;
    this.internalEvents = this.dimeloEvents.exchange;
    this.currentContactId = this.dimeloEvents.currentContact;
    this.selectSkills = this.dimeloEvents.selectSkills;
    forEach(this.availableContact, item => {
      if (item.id === this.currentContactId) {
        this.currentContact = item;
      }
    });
  }

  fullScreenContact(id: string): void {
    $('#FullscreenDimelo').css(
      'background-image',
      'url(' + 'https://atoswl-demo.engagement.dimelo.com/attachments/' + id + '?access_token=' + this.dimeloEvents.passId + ')'
    );
    $('#FullscreenDimelo').fadeIn();
  }

  fullScreenCsr(url: string): void {
    $('#FullscreenDimelo').css('background-image', 'url(' + url + ')');
    $('#FullscreenDimelo').fadeIn();
  }

  minScreen(): void {
    $('#FullscreenDimelo').fadeOut();
  }

  onApplyFilter(): void {
    let tmp: any = [];

    forEach(this.dimeloEvents.exchange, item => {
      if (item.source === 'CSR') {
        if (this.targetCsr !== null) {
          if (isDefined(this.targetCsr.id)) {
            if (item.user.id === this.targetCsr.id) {
              tmp.push(item);
            }
          }
        } else {
          tmp.push(item);
        }
      }
      if (item.source === 'CONTACT') {
        if (this.targetTypeContact === 0) {
          tmp.push(item);
        } else if (this.targetTypeContact === 1) {
          if (item.user.id === this.currentContact.id) {
            tmp.push(item);
          }
        } else if (this.targetTypeContact === 2) {
          if (this.targetContact !== null) {
            if (isDefined(this.targetContact.id)) {
              if (item.user.id === this.targetContact.id) {
                tmp.push(item);
              }
            }
          } else {
            tmp.push(item);
          }
        }
      }
    });
    this.internalEvents = tmp;
  }
  getExtensionFile(type): string {
    let tmp: string[] = type.split('/');
    if (tmp[0].toLowerCase() === 'text') {
      return 'doc';
    }
    if (tmp[0].toLowerCase() === 'application') {
      if (
        tmp[1].toLowerCase() === 'pdf' ||
        tmp[1].toLowerCase() === 'vnd.openxmlformats-officedocument.presentationml.presentation' ||
        tmp[1].toLowerCase() === 'powerpoint'
      ) {
        return 'pdf';
      }
    }
    if (tmp[0].toLowerCase() === 'application') {
      if (
        tmp[1].toLowerCase() === 'pdf' ||
        tmp[1].toLowerCase() === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        tmp[1].toLowerCase() === 'powerpoint'
      ) {
        return 'excel';
      }
    }
    return 'doc';
  }

  openNewTab(id) {
    window.open('https://atoswl-demo.engagement.dimelo.com/attachments/' + id + '?access_token=' + this.dimeloEvents.passId);
  }

  FileConvertSize(aSize): any {
    aSize = Math.abs(parseInt(aSize, 10));
    let def: any = [
      [1, 'octets'],
      [1024, 'ko'],
      [1024 * 1024, 'Mo'],
      [1024 * 1024 * 1024, 'Go'],
      [1024 * 1024 * 1024 * 1024, 'To'],
    ];
    for (let i: number = 0; i < def.length; i++) {
      if (aSize < def[i][0]) return (aSize / def[i - 1][0]).toFixed(2) + ' ' + def[i - 1][1];
    }
  }

  FileConvertName(file): string {
    let tmp: number = file.lastIndexOf('.');
    return this.$sce.trustAsHtml(file.slice(0, tmp));
  }

  FileConvertExt(file): string {
    let tmp: number = file.lastIndexOf('.');
    return file.slice(tmp + 1, file.length);
  }

  readableDateShort(dateToUse: Date): string {
    return this.timeUtil.readableDateShort(dateToUse);
  }

  readableTime(dateToUse: Date): string {
    return this.timeUtil.readableTime(dateToUse);
  }

  readableDateShortByNumber(dateToUse: number): string {
    return this.timeUtil.readableDateShort(dateToUse);
  }

  readableTimeByNumber(dateToUse: number): string {
    return this.timeUtil.readableTime(dateToUse);
  }
}

export class HistorySocialNetwork implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    dimeloEvents: '<',
  };
  controller = ['$log', '$i18next', 'momentService', '$sce', HistorySocialNetworkCtrl];
}

export default 'historySocialNetwork';
